<template>
  <div>
    <speaker v-if="track.speaker && track.speaker.name" :speaker-config="speakerConfig" :speaker="track.speaker"></speaker>
    <section class="con-track-info">
      <div class="container">
        <div class="left">
          <h5 v-if="track.time && $store.state.info.displayPresentationTime">
            <i class="icontfont icon-time"></i>时间：{{presentationTime}}
          </h5>
          <h5>
            <i class="iconfont icon-location"></i>地点：{{track.address?track.address:'待定'}}
          </h5>
        </div>
        <div class="right">
          <h1>培训：{{track.topic}}</h1>
          <div class="content" v-html="track.description">
          </div>
        </div>
      </div>
    </section>

    <section class="con-track-present" v-if="this.trainings.length">
      <div class="container">
        <router-link class="present" v-for="(training, id) in trainings" :key="id" :to="'/training/' + training.id" v-if="Number(training.id) !== 152">
            <div class="left">
              <div v-for="(sid, idx) in training.speakerIds" :key="idx" class="speaker" v-if="speakers[sid]">
                <h4>by <span>{{speakers[sid].name}}</span></h4>
                <h6>{{speakers[sid].company}}</h6><small>{{speakers[sid].position}}</small>
              </div>
            </div>
            <div class="right">
              <div class="title">{{training.title}}</div>
              <div class="content" v-html="training.intro"></div>
            </div>
        </router-link>
      </div>
    </section>

  </div>
</template>

<script>
import Speaker from 'gkConUI/com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  components: {
    Speaker
  },
  props: [
    'id'
  ],
  computed: {
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [] }
    },
    trainings () {
      return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    },
    speakers () {
      return this.$store.state.speakers
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass">

.con-track-info
  background-color: #fff
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .left
    width: 345px
    padding-right: 30px
    flex-shrink: 0
    +mobile
      display: none
    h5
      color: #8e9ca9
      font-size: 16px
      line-height: 1.8
      margin-top: 9px
      display: flex
      align-items: center
      i.iconfont
        margin-right: 8px
        color: var(--primary-color)
      a
        color: inherit
        &:hover
          color: var(--primary-color)
      img
        width: 18px
        margin-right: 11px
    +mobile
      width: 100%
      text-align: center
  .right
    flex-grow: 1
    > h1
      color: #3e3a39
      font-size: 38px
      margin-bottom: 50px

.con-track-present
  background-color: #f5f7f8
  padding: 67px 0 56px 0
  .left
    width: 304px
    margint-left: 10px
    flex-shrink: 0
    display: flex
    flex-direction: column
    justify-content: center
    .speaker
      margin: 15px 0
      h4
        font-size: 20px
        color: #3e3a39
        span
          font-size: 20px
          color: #1d5ea4
      h6, small
        font-size: 16px
        color: #8e9ca9
        margin-top: 9px
        line-height: 1.4em
  .right
    flex-grow: 1
    .title
      font-size: 30px
      padding-bottom: 13px
      margin-bottom: 20px
  .present
    display: flex
    padding: 50px 42px
    border-left: 8px solid #1d5ea4
    margin-bottom: 20px
    background-color: #fff
    color: #3e3a39
    &:hover
      box-shadow: 0 0 10px rgba(218, 227, 237, .8)
</style>
